var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.officeRosterUser]
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('ProfilePicture', {
    class: _vm.$style.profilePicture,
    attrs: {
      "src": _vm.user.photoUrl
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.viewProfile(true, _vm.user);
      }
    }
  }), _c('div', {
    class: _vm.$style.contentContainer
  }, [_c('p', {
    staticClass: "tag-text",
    class: [_vm.$style.userStatusText, _vm.tooltipMessage ? _vm.$style.userStatusTextWithTooltip : ''],
    style: {
      color: _vm.getStatusTextColor
    }
  }, [_vm._v(" " + _vm._s(_vm.userStatusFormatter(_vm.user.status)) + " ")]), _c('div', [_c('p', {
    staticClass: "button-text color-primary-blue",
    class: _vm.$style.name
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm.tooltipMessage ? _c('Tooltip', {
    class: _vm.$style.pendingTooltip,
    attrs: {
      "target": "".concat(_vm.user.id, "tooltip"),
      "placement": "top",
      "theme": "orange",
      "icon-color": "orange"
    }
  }, [_vm._v(" " + _vm._s(_vm.tooltipMessage) + " ")]) : _vm._e()], 1), _c('div', [_vm._l(_vm._.take(_vm.user.groupLabels, 3), function (label) {
    return _c('div', {
      key: label,
      staticClass: "position-relative width-fit-content"
    }, [_c('p', {
      staticClass: "overline-text color-primary-blue"
    }, [_vm._v(" " + _vm._s(label) + " "), _vm.tooltipMLOMessage && label === 'MLO Phase 2 (pending)' ? _c('Tooltip', {
      staticClass: "ml-1",
      attrs: {
        "target": "".concat(_vm.user.id, "tooltip-mlo"),
        "placement": "top",
        "theme": "orange",
        "icon-color": "orange",
        "icon-absolute-position": false
      }
    }, [_vm._v(" " + _vm._s(_vm.tooltipMLOMessage) + " ")]) : _vm._e()], 1)]);
  }), _vm.user.groupLabels.length === 4 ? [_c('p', {
    staticClass: "overline-text color-primary-blue"
  }, [_vm._v(_vm._s(_vm.user.groupLabels[3]))])] : _vm.user.groupLabels.length > 4 ? [_c('p', {
    staticClass: "width-fit-content overline-text color-primary-blue",
    attrs: {
      "id": "show-more-roles-tooltip-user-pill-".concat(_vm.user.id)
    }
  }, [_vm._v(" + " + _vm._s(_vm.user.groupLabels.length - 3) + " more ")]), _c('b-tooltip', {
    attrs: {
      "target": "show-more-roles-tooltip-user-pill-".concat(_vm.user.id),
      "placement": "bottom",
      "custom-class": "tooltipBlue",
      "no-fade": ""
    }
  }, _vm._l(_vm._.slice(_vm.user.groupLabels, 3), function (label) {
    return _c('p', {
      key: label,
      staticClass: "color-white text-center"
    }, [_vm._v(" " + _vm._s(label) + " ")]);
  }), 0)] : _vm._e()], 2)])], 1), _c('div', {
    class: _vm.$style.buttonContainer
  }, [_c('BaseButton', {
    style: {
      visibility: !_vm.isUserMe(_vm.user) ? 'visible' : 'hidden'
    },
    attrs: {
      "theme": "blue",
      "options": {
        defaultPadding: false
      }
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.viewProfile(false, _vm.user);
      },
      "mousedown": function mousedown($event) {
        if ('button' in $event && $event.button !== 1) { return null; }
        $event.preventDefault();
        return _vm.viewProfile(true, _vm.user);
      }
    }
  }, [_vm._v(" View Profile ")]), _c('BaseButton', {
    attrs: {
      "theme": "blue",
      "options": {
        defaultPadding: false
      },
      "disabled": _vm.user.isAccessOnly || _vm.user.isHQUser || !_vm.isUserInteractable(_vm.user)
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('update-role', _vm.user);
      }
    }
  }, [_vm._v(" Update Role ")]), _c('BaseButton', {
    attrs: {
      "theme": "blue",
      "options": {
        defaultPadding: false
      },
      "disabled": !_vm.isUserInteractable(_vm.user) || _vm.isUserMe(_vm.user) || _vm.isDisabledDeactivateButton(_vm.user)
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('deactivate-user', _vm.user);
      }
    }
  }, [_vm._v(" Deactivate ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }